import { updatePrivateMessage } from '@moal/api'
import { useState } from 'react'
import { EDIT_MESSAGE } from '../../../constants/actions/messageListActions'
import { toastError, toastSuccess } from '../../../utils/toast'
import ToggleSwitchLocal from '../../Forms/common/ToggleSwitchLocal'
import Modal from '../../Utilities/Modal'
import PrivateMessage from '../PrivateMessage'

const SendPMToEveryoneModal = ({ open, setOpen, message, dispatch }) => {
  const [sendGlobalDM, setSendGlobalDM] = useState(message.toEveryone ?? true)

  const handleSendToEveryone = async () => {
    const response = await updatePrivateMessage({
      token: localStorage.getItem('authToken'),
      id: message._id,
      message: message.message,
      toEveryone: sendGlobalDM
    })
    if (response && response.status === 200) {
      dispatch({ type: EDIT_MESSAGE, payload: response.data })

      if (sendGlobalDM) {
        toastSuccess('Message sent.')
      } else {
        toastSuccess('Message changed to private.')
      }
    } else {
      toastError('Failed to send message')
    }
    setOpen(false)
  }

  return (
    <Modal
      title="Send Private Message to Everyone"
      open={open}
      setOpen={(value) => {
        setSendGlobalDM(message.toEveryone ?? true)
        setOpen(value)
      }}
      confirmFunction={handleSendToEveryone}
      size="md"
    >
      <div className="flex flex-col gap-3 w-full">
        <PrivateMessage message={message} />
        <div className="w-fit">
          <ToggleSwitchLocal
            setting="sendGlobalDM"
            value={sendGlobalDM}
            label="Send to Everyone"
            color="green"
            setter={setSendGlobalDM}
          />
        </div>
      </div>
    </Modal>
  )
}

export default SendPMToEveryoneModal
